import React from "react";
import { useDispatch, useSelector } from "react-redux";
import cn from "classnames";
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import Geocode from "react-geocode";
import { Uploader } from "services/action";
import { logo64 } from "utilities/common";

var watermark = require("watermarkjs");
var moment = require("moment");
const textToImage = require("text-to-image");
var MobileDetect = require("mobile-detect");
var md = new MobileDetect(window.navigator.userAgent);

Geocode.setApiKey("AIzaSyCLxGBGLUUDJVq-7TpWuPAz72HjsPc3fOA");
Geocode.setLanguage("id");
Geocode.setLocationType("ROOFTOP");

const ImagePreview = ({ dataUri }) => {
  const StateForm = useSelector((state) => state?.Form);

  return (
    <div className={cn("demo-image-preview")} id="lower-left">
      <img src={dataUri} alt="" />

      <div className="camera-button-action">
        {StateForm?.errors?.id ? (
          <div
            className="text-center"
            style={{ marginBottom: 5, marginTop: 10 }}
          >
            <span style={{ color: "red" }}>{StateForm?.errors?.id}</span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

const CameraScreen = ({ code, setImg, onClose, numberImg, type }) => {
  const Dispatch = useDispatch();

  const [address, setAddress] = React.useState(null);
  const [pos, setPos] = React.useState(null);
  const [image, setImage] = React.useState("");

  function dataURItoBlob(dataURI) {
    let byteString = atob(dataURI.split(",")[1]);

    // separate out the mime component
    let mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    let blob = new Blob([ab], { type: mimeString });
    return blob;
  }

  function padWithZeroNumber(number, width) {
    number = number + "";
    return number.length >= width
      ? number
      : new Array(width - number.length + 1).join("0") + number;
  }

  function getFileExtention(blobType) {
    // by default the extention is .png
    let extention = IMAGE_TYPES.PNG;

    if (blobType === "image/jpeg") {
      extention = IMAGE_TYPES.JPG;
    }
    return extention;
  }

  function getFileName(imageNumber, blobType) {
    const prefix = `${type}-${code}`;
    const photoNumber = padWithZeroNumber(imageNumber, 4);
    const extention = getFileExtention(blobType);

    return `${prefix}-${photoNumber}.${extention}`;
  }

  function downloadImageFileFomBlob(blob, imageNumber) {
    window.URL = window.webkitURL || window.URL;

    let anchor = document.createElement("a");
    anchor.download = getFileName(imageNumber, blob.type);
    anchor.href = window.URL.createObjectURL(blob);
    let mouseEvent = document.createEvent("MouseEvents");
    mouseEvent.initMouseEvent(
      "click",
      true,
      true,
      window,
      1,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null
    );
    anchor.dispatchEvent(mouseEvent);
  }

  function downloadImageFile(dataUri, imageNumber) {
    let blob = dataURItoBlob(dataUri);
    downloadImageFileFomBlob(blob, imageNumber);
  }

  const handleCapture = (u) => {
    const dataUri = textToImage.generateSync(
      `${moment().format("llll")}\n${pos?.lat}, ${pos?.lng}\n${address}`,
      {
        bgColor: "#000",
        textColor: "#fff",
        textAlign: "right",
        maxWidth: 300,
        fontSize: 12,
        lineHeight: 13,
      }
    );

    let x = watermark([u, dataUri])
      .image(watermark.image.lowerRight(0.8))
      .then(async function (img) {
        let y = document.querySelector(".demo-image-preview").appendChild(img);
        y.id = "foto";
        let x = document.querySelector("img#foto").src;
        var image_x = document.getElementById("foto");

        watermark([x, logo64()])
          .image(watermark.image.lowerLeft())
          .then(async function (img) {
            let y = document
              .querySelector(".demo-image-preview")
              .appendChild(img);
            y.id = "logo";
            let x = document.querySelector("img#logo").src;
            var image_y = document.getElementById("logo");

            $handleSave(x);
            let os = md.is("iPhone");

            if (os === false) {
              downloadImageFile(x, numberImg);
            }
            image_x.parentNode.removeChild(image_x);
            image_y.parentNode.removeChild(image_y);
            onClose();
          });
      });
    setImage(x);
  };

  const $handleSave = async (a) => {
    let payload = {
      file: a,
    };
    const req = await Dispatch(Uploader.$upload(payload));

    if (req?.message === "success") {
      const data = req?.data;
      setImg((img) => [...img, data]);
    }
  };

  React.useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        setPos({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });

        Geocode.fromLatLng(
          position.coords.latitude,
          position.coords.longitude
        ).then(
          (response) => {
            const address = response.results[0].formatted_address;
            setAddress(address);
          },
          (error) => {
            console.error(error);
          }
        );
      },
      (error) => {
        // See error code charts below.
        console.log(error.code, error.message);
      },
      { enableHighAccuracy: true, timeout: 60000, maximumAge: Infinity }
    );
  }, []);

  return (
    <div>
      <Camera
        onTakePhoto={handleCapture}
        idealFacingMode={FACING_MODES.ENVIRONMENT}
        imageType={IMAGE_TYPES.JPG}
        imageCompression={1}
        isMaxResolution={false}
        isImageMirror={false}
      />

      <div className="d-none">
        <ImagePreview dataUri={image} />
      </div>
    </div>
  );
};

export default CameraScreen;
